import React from 'react'

type Props = {
  size?: number
}

const IconEMOM = ({ size = 32 }: Props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="12.5" r="9.5" stroke="#16DB70" strokeWidth="2" />
      <path
        d="M8 1C8 0.447715 8.44772 0 9 0H12C12.5523 0 13 0.447715 13 1V3H8V1Z"
        fill="#16DB70"
      />
      <path
        d="M17.1569 2.30763C17.5474 1.91711 18.1806 1.91711 18.5711 2.30763L20.6924 4.42895C21.083 4.81948 21.083 5.45264 20.6924 5.84317L19.2782 7.25738L15.7427 3.72185L17.1569 2.30763Z"
        fill="#16DB70"
      />
      <path
        d="M9.214 7.33199L7.59 11.518L7.618 11.546C7.66467 11.5087 7.73467 11.4807 7.828 11.462C7.93067 11.434 8.06133 11.42 8.22 11.42C8.472 11.42 8.70533 11.4807 8.92 11.602C9.13467 11.7233 9.30267 11.8773 9.424 12.064C9.48933 12.1667 9.54067 12.2693 9.578 12.372C9.61533 12.4747 9.648 12.61 9.676 12.778C9.69467 12.946 9.70867 13.1607 9.718 13.422C9.72733 13.674 9.732 13.996 9.732 14.388C9.732 14.7147 9.72733 14.9853 9.718 15.2C9.70867 15.4053 9.69467 15.578 9.676 15.718C9.648 15.8673 9.61067 15.9933 9.564 16.096C9.52667 16.1987 9.47533 16.306 9.41 16.418C9.22333 16.726 8.97133 16.964 8.654 17.132C8.346 17.3 7.996 17.384 7.604 17.384C7.212 17.384 6.862 17.3 6.554 17.132C6.246 16.9547 5.99867 16.7167 5.812 16.418C5.73733 16.306 5.67667 16.1987 5.63 16.096C5.59267 15.9933 5.56467 15.8673 5.546 15.718C5.518 15.578 5.49933 15.4053 5.49 15.2C5.48067 14.9853 5.476 14.7147 5.476 14.388C5.476 14.08 5.48067 13.828 5.49 13.632C5.49933 13.4267 5.51333 13.2493 5.532 13.1C5.55067 12.96 5.57867 12.834 5.616 12.722C5.65333 12.6007 5.69533 12.4747 5.742 12.344L7.618 7.33199H9.214ZM8.304 13.394C8.304 13.1793 8.234 13.0067 8.094 12.876C7.954 12.7453 7.79067 12.68 7.604 12.68C7.41733 12.68 7.254 12.7453 7.114 12.876C6.974 13.0067 6.904 13.1793 6.904 13.394V15.242C6.904 15.4567 6.974 15.6293 7.114 15.76C7.254 15.8907 7.41733 15.956 7.604 15.956C7.79067 15.956 7.954 15.8907 8.094 15.76C8.234 15.6293 8.304 15.4567 8.304 15.242V13.394ZM10.685 9.38999C10.685 9.05399 10.741 8.75532 10.853 8.49399C10.9743 8.23265 11.133 8.00865 11.329 7.82199C11.525 7.63532 11.749 7.49532 12.001 7.40199C12.2623 7.29932 12.533 7.24799 12.813 7.24799C13.093 7.24799 13.359 7.29932 13.611 7.40199C13.8723 7.49532 14.101 7.63532 14.297 7.82199C14.493 8.00865 14.647 8.23265 14.759 8.49399C14.8803 8.75532 14.941 9.05399 14.941 9.38999V15.242C14.941 15.578 14.8803 15.8767 14.759 16.138C14.647 16.3993 14.493 16.6233 14.297 16.81C14.101 16.9967 13.8723 17.1413 13.611 17.244C13.359 17.3373 13.093 17.384 12.813 17.384C12.533 17.384 12.2623 17.3373 12.001 17.244C11.749 17.1413 11.525 16.9967 11.329 16.81C11.133 16.6233 10.9743 16.3993 10.853 16.138C10.741 15.8767 10.685 15.578 10.685 15.242V9.38999ZM12.113 15.242C12.113 15.4473 12.1783 15.62 12.309 15.76C12.4397 15.8907 12.6077 15.956 12.813 15.956C13.0183 15.956 13.1863 15.8907 13.317 15.76C13.4477 15.62 13.513 15.4473 13.513 15.242V9.38999C13.513 9.18465 13.4477 9.01665 13.317 8.88599C13.1863 8.74599 13.0183 8.67599 12.813 8.67599C12.6077 8.67599 12.4397 8.74599 12.309 8.88599C12.1783 9.01665 12.113 9.18465 12.113 9.38999V15.242Z"
        fill="black"
      />
      <path
        d="M22 22H30"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22 26H30"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22 30H30"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="19" cy="22" r="1" fill="black" />
      <circle cx="19" cy="26" r="1" fill="black" />
      <circle cx="19" cy="30" r="1" fill="black" />
    </svg>
  )
}

export default IconEMOM
